<template>
    <form @submit.prevent="handleSubmit()" class="loan-application p-4 md:p-12 xl:p-20 relative qwer">
        <template v-if="currentLocale === 'sv-SE'">
            <div v-if="loading" class="absolute inset-0 bg-white bg-opacity-40 z-50">
                <div class="loading-indicator"></div>
            </div>
            <div v-if="showErrors" class="my-8 p-4 border border-red-300 rounded-regular bg-red-100">
                <ul>
                    <li v-for="fieldErrors in errors" :key="fieldErrors">
                        <span v-for="fieldError in fieldErrors" :key="fieldError">
                            {{ fieldError }}
                        </span>
                    </li>
                </ul>
            </div>

            <div class="my-8">
                <div v-if="currentPage == 1">
                    <div class="flex flex-row flex-wrap -mx-4">
                        <fieldset class="hidden">
                            <input type="hidden" v-model="formData.loanAmount">
                            <input type="hidden" v-model="formData.loanDuration">
                            <input type="hidden" v-model="formData.loanInterest">
                            <input type="hidden" v-model="formData.propertyCost">
                            <input type="hidden" v-model="formData.downPayment">
                        </fieldset>
                        <label class="w-full md:w-1/2 p-4 asdf">
                            {{ $t('Välj kontor') }}
                            <select v-model="formData.kontorId">
                                <option v-for="(kontor, key) in options.kontor" :value="key" :key="key">{{ kontor.name }}</option>
                            </select>
                        </label>
                        <label class="w-full md:w-1/2 p-4">
                            {{ $t('Hur många sökande') }}
                            <input v-model.number="formData.antalSokande" type="number" min="1" max="2">
                        </label>
                    </div>

                    <div v-for="(applicant, index) in formData.sokande" :key="index">
                        <fieldset class="fieldset mt-16 pt-8">
                            <legend class="text-sm font-normal text-green-500 uppercase">{{ $t('Personuppgifter: sökande {index}', {index: (index + 1)}) }}</legend>
                            <div class="flex flex-row flex-wrap -mx-4">
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('För- och efternamn') }}
                                    <input type="text" v-model="applicant.foernamnefternamn" autocomplete="name">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Kommun och gatuadress') }}
                                    <input type="text" v-model="applicant.adress">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Telefon') }}
                                    <input type="text" v-model="applicant.telefon" autocomplete="tel">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Email') }}
                                    <input type="email" v-model="applicant.email" autocomplete="email">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Ditt sparkapital (efter bostadsköp)') }}
                                    <input type="number" v-model="applicant.sparande">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Födelseår') }}
                                    <input v-model.number="applicant.foedelsear" type="number">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Månadsinkomst före skatt') }}
                                    <input type="number" v-model="applicant.nettoloensekMan" min="0">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Arbetsgivare') }}
                                    <input type="text" v-model="applicant.arbetsgivare" autocomplete="organization">
                                </label>
                                <fieldset class="w-full m-4">
                                    <legend class="text-left p-0">{{ $t('Anställningsform') }}</legend>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" v-model="applicant.anstallningsform" value="Fasttillsvidareanstalld">
                                        {{ $t('Fast/tillsvidareanställd') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" v-model="applicant.anstallningsform" value="Egenforetagare">
                                        {{ $t('Egen företagare') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" v-model="applicant.anstallningsform" value="pensionaer">
                                        {{ $t('Pensionär') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" v-model="applicant.anstallningsform" value="Visstidsprojektanstalld">
                                        {{ $t('Visstids/projektanställd') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" v-model="applicant.anstallningsform" value="oevrigt">
                                        {{ $t('Övrigt') }}
                                    </label>
                                </fieldset>
                            </div>
                        </fieldset>
                    </div>
                    <div>
                        <fieldset class="fieldset mt-16 pt-8">
                            <div class="flex flex-row flex-wrap -mx-4">
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Lånebelopp') }}
                                    <input type="number" v-model="formData.lanebelopp" min="0">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Marknadsvärde') }}
                                    <input type="number" v-model="formData.marknadsvardes">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Adress för bostad som ska belånas') }}
                                    <input type="text" v-model="formData.adressvalue">
                                </label>
                                <fieldset class="w-full m-4">
                                    <legend class="text-left p-0">{{ $t('Typ av bostad som belånas') }}</legend>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="typAvBostad" v-model="formData.typAvBostad" value="villa">
                                        {{ $t('Villa') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="typAvBostad" v-model="formData.typAvBostad" value="bostadsraett">
                                        {{ $t('Bostadsrätt') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="typAvBostad" v-model="formData.typAvBostad" value="fritidshus">
                                        {{ $t('Fritidshus') }}
                                    </label>
                                </fieldset>
                            </div>
                        </fieldset>
                        <div class="mb-4 mt-18">
                            <label class="flex flex-row">
                                <div class="flex-1 mr-4">
                                    <input type="checkbox" v-model="formData.integritetspolicy">
                                </div>
                                <p class="flex-auto text-base" v-html="integritetspolicyText">
                                </p>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- Page 2 -->
                <div v-if="currentPage == 2" class="my-4">
                    <div class="p-4">
                        <h2 class="text-xl uppercase text-center my-8">{{ $t('Tack för låneansökan!') }}</h2>
                        <p class="text-center my-8">{{ $t('Vi tar kontakt så fort som möjligt.') }}</p>
                    </div>
                </div>
                <!-- End page 2 -->
            </div>
            <!-- Submit buttons -->
            <div class="mt-8 flex flex-wrap justify-between">
                <button type="submit" v-if="currentPage == 1" class="button ml-auto mt-4 mb-0 mr-0 w-full md:w-auto">{{ $t('Skicka') }}</button>
            </div>
            <!-- End submit buttons -->
        </template>
        <template v-else>
            <div v-if="loading" class="absolute inset-0 bg-white bg-opacity-40 z-50">
                <div class="loading-indicator"></div>
            </div>

            <ol class="loan-application__page-indicator">
                <li :class="pageIndicator(1)"><span>{{ $t('Start') }}</span></li>
                <li :class="pageIndicator(2)"><span>{{ $t('Sökande') }}</span></li>
                <li :class="pageIndicator(3)"><span>{{ $t('Lånets ändamål') }}</span></li>
                <li :class="pageIndicator(4)"><span>{{ $t('Säkerheter') }}</span></li>
                <li :class="pageIndicator(5)"><span>{{ $t('Inkomster och utgifter') }}</span></li>
                <li :class="pageIndicator(6)"><span>{{ $t('Tillgångar och skulder') }}</span></li>
                <li :class="pageIndicator(7)"><span>{{ $t('Samtliga befintliga lån') }}</span></li>
                <li :class="pageIndicator(8)"><span>{{ $t('Övriga upplysningar') }}</span></li>
                <li :class="pageIndicator(9)"><span>{{ $t('Sammanfattning') }}</span></li>
                <li :class="pageIndicator(10)"><span>{{ $t('Lämnats!') }}</span></li>
            </ol>

            <div v-if="showErrors" class="my-8 p-4 border border-red-300 rounded-regular bg-red-100">
                <ul>
                    <li v-for="fieldErrors in errors" :key="fieldErrors">
                        <span v-for="fieldError in fieldErrors" :key="fieldError">
                            {{ fieldError }}
                        </span>
                    </li>
                </ul>
            </div>

            <div class="my-8">

                <!-- Page 1 -->
                <div v-if="currentPage == 1" class="flex flex-row flex-wrap -mx-4">

                    <label class="w-full md:w-1/2 p-4">
                        {{ $t('Välj kontor') }}
                        <select v-model="formData.kontorId">
                            <option v-for="(kontor, key) in options.kontor" :value="key" :key="key">{{ kontor.name }}</option>
                        </select>
                    </label>
                    <label class="w-full md:w-1/2 p-4">
                        {{ $t('Hur många sökande') }}
                        <input v-model.number="formData.antalSokande" type="number" min="1" max="2">
                    </label>

                    <label class="w-full md:w-1/2 p-4">
                        {{ $t('Jag är Ålandsbankens kund') }}
                        <select v-model="formData.nyKund">
                            <option v-for="(nyKund, key) in options.nyKund" :key="key" :value="key">{{ nyKund }}</option>
                        </select>
                    </label>
                </div>
                <!-- End page 1 -->

                <!-- Page 2 -->
                <div v-if="currentPage == 2">
                    <div v-for="(applicant, index) in formData.sokande" :key="index">
                        <fieldset class="fieldset mt-16 pt-8">
                            <legend class="text-sm font-normal text-green-500 uppercase">{{ $t('Personuppgifter: sökande {index}', {index: (index + 1)}) }}</legend>
                            <div class="flex flex-row flex-wrap -mx-4">
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Förnamn') }}
                                    <input type="text" v-model="applicant.fornamn" autocomplete="given-name">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Efternamn') }}
                                    <input type="text" v-model="applicant.efternamn" autocomplete="family-name">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Personnummer') }}
                                    <input type="text" v-model="applicant.personnummer" :placeholder="$t('DDMMÅÅ-NNNN')">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Adress') }}
                                    <input type="text" v-model="applicant.adress" autocomplete="street-address">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Postnummer') }}
                                    <input type="text" v-model="applicant.postnummer" autocomplete="postal-code">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Ort') }}
                                    <input type="text" v-model="applicant.ort" autocomplete="address-level2">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Telefon') }}
                                    <input type="text" v-model="applicant.telefon" autocomplete="tel">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Epost') }}
                                    <input type="email" v-model="applicant.epost" autocomplete="email">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Civilstånd') }}
                                    <input type="text" v-model="applicant.civilstand">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Antal barn att försörja') }}
                                    <input type="number" v-model="applicant.antalBarn">
                                </label>
                                <fieldset class="w-full m-4">
                                    <legend class="text-left p-0">{{ $t('Boendeform') }}</legend>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="boendeform" v-model="applicant.boendeform" value="egenbostad">
                                        {{ $t('Egen bostad') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="boendeform" v-model="applicant.boendeform" value="hyreslagenhet">
                                        {{ $t('Hyreslägenhet') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="boendeform" v-model="applicant.boendeform" value="bostadsratt">
                                        {{ $t('Bostadsrätt') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="boendeform" v-model="applicant.boendeform" value="tjanstebostad">
                                        {{ $t('Tjänstebostad') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="boendeform" v-model="applicant.boendeform" value="annan">
                                        {{ $t('Annan') }}
                                    </label>
                                </fieldset>
                                <fieldset class="w-full m-4">
                                    <legend class="text-left p-0">{{ $t('Utbildning') }}</legend>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="utbildning" v-model="applicant.utbildning" value="grundskola">
                                        {{ $t('Grundskola') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="utbildning" v-model="applicant.utbildning" value="gymnasie">
                                        {{ $t('Gymnasie') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="utbildning" v-model="applicant.utbildning" value="yrkesskola">
                                        {{ $t('Yrkesskola') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="utbildning" v-model="applicant.utbildning" value="yrkeshogskola">
                                        {{ $t('Yrkeshögskola') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="utbildning" v-model="applicant.utbildning" value="lagrehogskoleexamen">
                                        {{ $t('Lägre högskoleexamen') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="utbildning" v-model="applicant.utbildning" value="hogrehogskoleexamen">
                                        {{ $t('Högre högskoleexamen') }}
                                    </label>
                                </fieldset>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Arbetsgivare') }}
                                    <input type="text" v-model="applicant.arbetsgivare" autocomplete="organization">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Yrke/studerande/pensionär') }}
                                    <input type="text" v-model="applicant.yrke" autocomplete="organization-title">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Telefon arbete') }}
                                    <input type="text" v-model="applicant.telefonArbete">
                                </label>
                                <fieldset class="w-full m-4">
                                    <legend class="text-left p-0">{{ $t('Anställningsform') }}</legend>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="anstallningsform" v-model="applicant.anstallningsform" value="fastAnstallning">
                                        {{ $t('Fast anställning') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="anstallningsform" v-model="applicant.anstallningsform" value="visstidsAnstalld">
                                        {{ $t('Visstids anställd') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="anstallningsform" v-model="applicant.anstallningsform" value="egenForetagare">
                                        {{ $t('Egen företagare') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="anstallningsform" v-model="applicant.anstallningsform" value="tjanstledig">
                                        {{ $t('Tjänstledig') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="anstallningsform" v-model="applicant.anstallningsform" value="foraldraledig">
                                        {{ $t('Föräldraledig') }}
                                    </label>
                                    <label class="inline-block mr-4 my-2">
                                        <input type="radio" name="anstallningsform" v-model="applicant.anstallningsform" value="arbetssokande">
                                        {{ $t('Arbetssökande') }}
                                    </label>
                                </fieldset>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Anställd år') }}
                                    <input type="number" v-model="applicant.anstalldAr">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Arbetserfarenhet totalt') }}
                                    <input type="number" v-model="applicant.arbetserfarenhetTotalt">
                                </label>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <!-- End page 2 -->

                <!-- Page 3 -->
                <div v-if="currentPage == 3" class="flex flex-row flex-wrap items-end -mx-4">
                    <fieldset class="w-full m-4">
                        <legend class="text-left p-0">{{ $t('Lånets ändamål') }}</legend>
                        <div class="flex flex-wrap flex-row items-center">
                            <label class="inline-block mr-4 my-2">
                                <input type="radio" name="lanetsAndamal" value="egenbostad" v-model="formData.lanetsAndamal">
                                {{ $t('Egen bostad') }}
                            </label>
                            <label class="inline-block mr-4 my-2">
                                <input type="radio" name="lanetsAndamal" value="investeringsbostad" v-model="formData.lanetsAndamal">
                                {{ $t('Investeringsbostad') }}
                            </label>
                            <label class="inline-block mr-4 my-2">
                                <input type="radio" name="lanetsAndamal" value="annat" v-model="formData.lanetsAndamal">
                                {{ $t('Annat') }}
                            </label>
                            <label class="inline-block flex-auto my-2">
                                <span class="sr-only">{{ $t('Annat ändamål') }}</span>
                                <input class="option-input" type="text" v-model="formData.lanetsAndamalAnnat" :disabled="formData.lanetsAndamal != 'annat'">
                            </label>
                        </div>
                    </fieldset>

                    <label class="w-full md:w-1/2 p-4">
                        {{ $t('Ansökt belopp') }}
                        <input type="number" v-model="formData.ansoktBelopp" min="0">
                    </label>

                    <label class="w-full md:w-1/2 p-4">
                        {{ $t('Önskad månadsrat inklusive amortering och ränta') }}
                        <input type="number" v-model="formData.onskadManadsRat" min="0">
                    </label>

                    <label class="w-full md:w-1/2 p-4">
                        {{ $t('Egen finansiering') }}
                        <input type="number" v-model="formData.egenFinansiering" min="0">
                    </label>
                </div>
                <!-- End page 3 -->

                <!-- Page 4 -->
                <div v-if="currentPage == 4" class="flex flex-row flex-wrap -mx-4">
                    <fieldset class="w-full m-4">
                        <legend class="text-left p-0">{{ $t('Säkerheter') }}</legend>
                        <p v-if="currentLocale == 'fi-FI' || currentLocale == 'sv-FI'" class="text-base pt-4 pb-8" style="color: #686868">{{$t("collateralDescription")}}</p>
                        <label class="inline-block mr-4">
                            <input type="checkbox" name="sakerheter" v-model="formData.sakerheter" value="kopobjekt">
                            {{ $t('Köpobjekt') }}
                        </label>
                        <label class="inline-block mr-4 my-2">
                            <input type="checkbox" name="sakerheter" v-model="formData.sakerheter" value="bostadsaktie">
                            {{ $t('Bostadsaktie') }}
                        </label>
                        <label class="inline-block mr-4 my-2">
                            <input type="checkbox" name="sakerheter" v-model="formData.sakerheter" value="fastighet">
                            {{ $t('Fastighet') }}
                        </label>
                        <label class="inline-block mr-4 my-2">
                            <input type="checkbox" name="sakerheter" v-model="formData.sakerheter" value="ovrigt">
                            {{ $t('Övrigt (t.ex. värdepappersförvar)') }}
                        </label>
                    </fieldset>
                    <label class="w-full p-4">
                        {{ $t('Ge en kort beskrivning av tillgängliga säkerheter.') }}
                        <textarea v-model="formData.sakerheterBesrivning"></textarea>
                    </label>
                </div>
                <!-- End page 4 -->

                <!-- Page 5 -->
                <div v-if="currentPage == 5">
                    <div v-for="applicant in formData.sokande" :key="applicant">
                        <fieldset class="fieldset mt-16 pt-8">
                            <legend class="text-sm font-normal text-green-500 uppercase">
                                {{ $t('Inkomster och utgifter: {fornamn} {efternamn}', {fornamn: applicant.fornamn, efternamn: applicant.efternamn}) }}
                            </legend>
                            <div class="flex flex-row flex-wrap -mx-4">
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Inkomster/månad (brutto)') }}
                                    <input type="number" v-model="applicant.inkomsterBrutto">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Inkomster/månad (netto)') }}
                                    <input type="number" v-model="applicant.inkomsterNetto">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Kapitalinkomster/månad (netto)') }}
                                    <input type="number" v-model="applicant.kapitalinkomsterNetto">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Övriga inkomster') }}
                                    <input type="number" v-model="applicant.ovrigaInkomster">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Din andel av boendekostnaderna') }}
                                    <input type="number" v-model="applicant.andelAvBoendekostnader">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Din andel av hushållets övriga kostnader') }}
                                    <input type="number" v-model="applicant.andelAvOvrigaKostnader">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Andra utgifter (t.ex. bil)') }}
                                    <input type="number" v-model="applicant.andraUtgifter">
                                </label>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <!-- End page 5 -->

                <!-- Page 6 -->
                <div v-if="currentPage == 6">
                    <div v-for="applicant in formData.sokande" :key="applicant">
                        <fieldset class="fieldset mt-16 pt-8">
                            <legend class="text-sm font-normal text-green-500 uppercase">
                                {{ $t('Tillgångar och skulder: {fornamn} {efternamn}', {fornamn: applicant.fornamn, efternamn: applicant.efternamn}) }}
                            </legend>
                            <div class="flex flex-row flex-wrap -mx-4 items-end">
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Bostad, marknadsvärde') }}
                                    <input type="number" v-model="applicant.bostadMarknadsvarde">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Sparande i Ålandsbanken') }}
                                    <input type="number" v-model="applicant.sparandeIAlandsbanken">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Sparande i andra banker') }}
                                    <input type="number" v-model="applicant.sparandeIAndraBanker">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Bostäder och andra tillgångar (investeringsbostäder, fritidsbostäder, andra fastigheter)') }}
                                    <input type="number" v-model="applicant.bostaderOchAndraTillgangar">
                                </label>
                                <label class="w-full md:w-1/2 p-4">
                                    {{ $t('Finansiella tillgångar (aktier, fonder, obligationer, försäkringssparande)') }}
                                    <input type="number" v-model="applicant.finansiellaTillgangar">
                                </label>

                                <fieldset class="w-full m-4">
                                    <legend>{{ $t('Skulder') }}</legend>
                                    <div class="flex flex-row flex-wrap -mx-4">
                                        <label class="w-full md:w-1/2 p-4">
                                            {{ $t('Lån med säkerhet i andra banker') }}
                                            <input type="number" v-model="applicant.lanMedSakerhetIAndraBanker">
                                        </label>
                                        <label class="w-full md:w-1/2 p-4">
                                            {{ $t('Lån utan säkerhet i andra banker') }}
                                            <input type="number" v-model="applicant.lanUtanSakerhetIAndraBanker">
                                        </label>
                                    </div>
                                </fieldset>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <!-- End page 6 -->

                <!-- Page 7 -->
                <div v-if="currentPage == 7">
                    <div v-for="(befitligtLan, index) in formData.befintligaLan" :key="index">
                        <fieldset class="fieldset mt-16 pt-8">
                            <legend class="text-sm font-normal text-green-500 uppercase">
                                {{ $t('Befintliga lån: {index}', {index: (index + 1)}) }}
                            </legend>
                            <div class="flex flex-row flex-wrap -mx-4">
                                <label class="w-1/2 p-4">
                                    {{ $t('Långivare') }}
                                    <input type="text" v-model="befitligtLan.langivare">
                                </label>
                                <label class="w-1/2 p-4">
                                    {{ $t('Nuvarande lånebelopp') }}
                                    <input type="text" v-model="befitligtLan.nuvarandeLanebelopp">
                                </label>
                                <label class="w-1/2 p-4">
                                    {{ $t('Bundet t.o.m.') }}
                                    <input type="text" v-model="befitligtLan.bundet">
                                </label>
                                <label class="w-1/2 p-4">
                                    {{ $t('Eventuell säkerhet') }}
                                    <input type="text" v-model="befitligtLan.eventuellSakerhet">
                                </label>
                            </div>
                            <button type="button" @click="removeExistingLoan(index)" class="text-green-400 my-2 hover:text-green-500 focus:text-green-500 hover:bg-transparent focus:bg-transparent focus:outline-none hover:underline focus:underline">
                                - {{ $t('Ta bort lån') }}
                            </button>
                        </fieldset>
                    </div>

                    <button type="button" @click="addExistingLoan()" class="text-green-400 my-2 hover:text-green-500 focus:text-green-500 hover:bg-transparent focus:bg-transparent focus:outline-none hover:underline focus:underline">
                        + {{ $t('Lägg till nytt lån') }}
                    </button>
                </div>
                <!-- End page 7 -->

                <!-- Page 8 -->
                <div v-if="currentPage == 8">
                    <label>
                        {{ $t('Övriga upplysningar') }}
                        <textarea v-model="formData.ovrigaUpplysningar">
                        </textarea>
                    </label>
                </div>
                <!-- End page 8 -->

                <!-- Page 9 -->
                <div v-if="currentPage == 9">
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">1 - {{ $t('Start') }}</h2>
                        <div class="flex flex-row flex-wrap my-4">
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Välj kontor') }}:</span>
                                <span>{{ selectedKontor }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Hur många sökande') }}:</span>
                                <span>{{ formData.antalSokande }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Jag är Ålandsbankens kund') }}:</span>
                                <span>{{ selectedNyKund }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">2 - {{ $t('Personuppgifter') }}</h2>
                        <div v-for="(sokande, index) in formData.sokande" :key="index" class="flex flex-row flex-wrap my-4">
                            <h3 class="w-full mb-4">{{ $t('Sökande {index}', {index: (index + 1)}) }}</h3>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Förnamn') }}:</span>
                                <span>{{ sokande.fornamn }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Efternamn') }}:</span>
                                <span>{{ sokande.efternamn }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Personnummer') }}:</span>
                                <span>{{ sokande.personnummer }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Adress') }}:</span>
                                <span>{{ sokande.adress }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Postnummer') }}:</span>
                                <span>{{ sokande.postnummer }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Ort') }}:</span>
                                <span>{{ sokande.ort }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Telefon') }}:</span>
                                <span>{{ sokande.telefon }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Epost') }}:</span>
                                <span>{{ sokande.epost }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Civilstånd') }}:</span>
                                <span>{{ sokande.civilstand }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Antal barn att försörja') }}:</span>
                                <span>{{ sokande.antalBarn }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Boendeform') }}:</span>
                                <span>{{ selectedBoendeform(sokande.boendeform) }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Utbildning') }}:</span>
                                <span>{{ selectedUtbildning(sokande.utbildning) }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Arbetsgivare') }}:</span>
                                <span>{{ sokande.arbetsgivare }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Yrke/studerande/pensionär') }}:</span>
                                <span>{{ sokande.yrke }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Telefon arbete') }}:</span>
                                <span>{{ sokande.telefonArbete }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Anställningsform') }}:</span>
                                <span>{{ selectedAnstallningsform(sokande.anstallningsform) }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Anställd år') }}:</span>
                                <span>{{ sokande.anstalldAr }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Arbetserfarenhet totalt') }}:</span>
                                <span>{{ sokande.arbetserfarenhetTotalt }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">3 - {{ $t('Lånets ändamål') }}</h2>
                        <div class="flex flex-row flex-wrap my-4">
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Lånets ändamål') }}:</span>
                                <span>{{ selectedLanetsAndamal }}</span>
                                <span v-if="formData.lanetsAndamalAnnat && formData.lanetsAndamal == 'annat'">: {{ formData.lanetsAndamalAnnat }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Ansökt belopp') }}:</span>
                                <span>{{ formData.ansoktBelopp }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Önskad månadsrat inklusive amortering och ränta') }}:</span>
                                <span>{{ formData.onskadManadsRat }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Egen finansiering') }}:</span>
                                <span>{{ formData.egenFinansiering }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="w-full uppercase text-green-500">4 - {{ $t('Säkerheter') }}</h2>
                        <div class="flex flex-row flex-wrap my-4">
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Säkerheter') }}:</span>
                                <span>{{ selectedSakerheter }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Beskrivning av tillgängliga säkerheter') }}:</span>
                                <span>{{ formData.sakerheterBesrivning }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">5 - {{ $t('Inkomster och utgifter') }}</h2>
                        <div v-for="(sokande, index) in formData.sokande" :key="index" class="flex flex-row flex-wrap my-4">
                            <h3 class="w-full">{{ $t('Inkomster och utgifter: {fornamn} {efternamn}', {fornamn: sokande.fornamn, efternamn: sokande.efternamn}) }}</h3>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Inkomster/månad (brutto)') }}:</span>
                                <span>{{ sokande.inkomsterBrutto }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Inkomster/månad (netto)') }}:</span>
                                <span>{{ sokande.inkomsterNetto }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Kapitalinkomster/månad (netto)') }}:</span>
                                <span>{{ sokande.kapitalinkomsterNetto }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Övriga inkomster') }}:</span>
                                <span>{{ sokande.ovrigaInkomster }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Andel av boendekostnaderna') }}:</span>
                                <span>{{ sokande.andelAvBoendekostnader }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Andel av hushållets övriga kostnader') }}:</span>
                                <span>{{ sokande.andelAvOvrigaKostnader }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Andra utgifter (t.ex. bil)') }}:</span>
                                <span>{{ sokande.andraUtgifter }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">6 - {{ $t('Inkomster och utgifter') }}</h2>
                        <div v-for="(sokande, index) in formData.sokande" :key="index" class="flex flex-row flex-wrap my-4">
                            <h3 class="w-full">{{ $t('Tillgångar och skulder: {fornamn} {efternamn}', {fornamn: sokande.fornamn, efternamn: sokande.efternamn}) }}</h3>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Bostad, marknadsvärde') }}:</span>
                                <span>{{ sokande.bostadMarknadsvarde }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Sparande i Ålandsbanken') }}:</span>
                                <span>{{ sokande.sparandeIAlandsbanken }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Sparande i andra banker') }}:</span>
                                <span>{{ sokande.sparandeIAndraBanker }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Bostäder och andra tillgångar (investeringsbostäder, fritidsbostäder, andra fastigheter)') }}:</span>
                                <span>{{ sokande.bostaderOchAndraTillgangar }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Finansiella tillgångar (aktier, fonder, obligationer, försäkringssparande)') }}:</span>
                                <span>{{ sokande.finansiellaTillgangar }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Lån med säkerhet i andra banker') }}:</span>
                                <span>{{ sokande.lanMedSakerhetIAndraBanker }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Lån utan säkerhet i andra banker') }}:</span>
                                <span>{{ sokande.lanUtanSakerhetIAndraBanker }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">7 - {{ $t('Samtliga befintliga lån') }}</h2>
                        <div v-for="(befiltligtLan, index) in formData.befintligaLan" :key="index" class="flex flex-row flex-wrap my-4">
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Långivare') }}:</span>
                                <span>{{ befiltligtLan.langivare }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Nuvarande lånebelopp') }}:</span>
                                <span>{{ befiltligtLan.nuvarandeLanebelopp }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Bundet t.o.m.') }}:</span>
                                <span>{{ befiltligtLan.bundet }}</span>
                            </div>
                            <div class="w-full md:w-1/2">
                                <span class="text-gray-500 mr-2">{{ $t('Eventuell säkerhet') }}:</span>
                                <span>{{ befiltligtLan.eventuellSakerhet }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h2 class="uppercase text-green-500">8 - {{ $t('Övriga upplysningar') }}</h2>
                        <div class="flex flex-row flex-wrap my-4">
                            <div class="w-full">
                                <span class="text-gray-500 mr-2">{{ $t('Övriga upplysningar') }}:</span>
                                <span>{{ formData.ovrigaUpplysningar }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4 mt-18">
                        <label class="flex flex-row">
                            <div class="flex-1 mr-4">
                                <input type="checkbox" v-model="formData.integritetspolicy">
                            </div>
                            <p class="flex-auto text-base" v-html="integritetspolicyText">

                            </p>
                        </label>
                    </div>
                </div>
                <!-- End page 9 -->

                <!-- Page 10 -->
                <div v-if="currentPage == 10" class="my-4">
                    <div class="p-4">
                        <h2 class="text-xl uppercase text-center my-8">{{ $t('Tack för låneansökan!') }}</h2>
                        <p class="text-center my-8">{{ $t('Vi tar kontakt så fort som möjligt.') }}</p>
                    </div>
                </div>
                <!-- End page 10 -->

            </div>

            <!-- Submit buttons -->
            <div class="mt-8 flex flex-wrap justify-between">
                <button type="button" v-if="currentPage < 9" @click="nextPage()" class="button ml-auto mt-4 mb-0 mr-0 w-full md:w-auto">{{ $t('Nästa') }}</button>
                <button type="submit" v-if="currentPage == 9" class="button ml-auto mt-4 mb-0 mr-0 w-full md:w-auto">{{ $t('Skicka') }}</button>
                <button type="button" v-if="currentPage > 1 && currentPage < 10" @click="previousPage()" class="button md:order-first mt-4 mb-0 w-full md:w-auto">{{ $t('Föregående') }}</button>
            </div>
            <!-- End submit buttons -->
        </template>
    </form>
</template>

<script>

import axios from 'axios';
import size from 'lodash/size';
import join from 'lodash/join';
import find from 'lodash/find';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import { translations, translate } from '../../_translations'

export default {
    props: {
        options: {
            type: Object,
            default: {},
        },

        translations: {
            type: Object,
            default: {},
        },

        links: {
            type: Object,
            default: {},
        }
    },

    data() {
        return {
            formData: window.currentLocale === 'sv-SE' ? {
                loanAmount: this.getParameterByName('ccalc_sum'),
                loanDuration: this.getParameterByName('ccalc_period'),
                loanInterest: this.getParameterByName('ccalc_percent'),
                propertyCost: this.getParameterByName('propertyCost'),
                downPayment: this.getParameterByName('downPayment'),
                kontorId: Object.keys(this.options.kontor)[0],
                antalSokande: 1,
                sokande:  [this.applicantDataSweden()],
                lanebelopp: '',
                marknadsvardes: '',
                adressvalue: '',
                typAvBostad: ''
            } : {
                kontorId: Object.keys(this.options.kontor)[0],
                antalSokande: 1,
                sokande: [this.applicantData()],
                lanetsAndamal: '',
                lanetsAndamalAnnat: '',
                ansoktBelopp: '',
                onskadManadsRat: '',
                egenFinansiering: '',
                sakerheter: [],
                sakerheterBesrivning: '',
                befintligaLan: [this.existingLoanData()],
                ovrigaUpplysningar: '',
                godkannVillkor: false,
                integritetspolicy: false,
                nyKund: Object.keys(this.options.nyKund)[0],
            },
            currentLocale: window.currentLocale,
            currentPage: 1,
            errors: {},
            loading: true,
        }
    },

    computed: {
        showErrors() {
            return !!size(this.errors);
        },

        selectedKontor() {
            let kontor = find(this.options.kontor, (o, i) => {return i == this.formData.kontorId});

            return !!kontor ? kontor.name : '';
        },

        selectedNyKund() {
            return find(this.options.nyKund, (o, i) => {return i == this.formData.nyKund});
        },

        selectedLanetsAndamal() {
            return find(this.options.lanetsAndamal, (o, i) => {return i == this.formData.lanetsAndamal});
        },

        selectedSakerheter() {
            return join(filter(this.options.sakerheter, (o, i) => {return includes(this.formData.sakerheter, i)}), ', ');
        },

        integritetspolicyText() {
            return translate('Jag har läst och förstått <a href="{link}" target="_blank">Ålandsbankens Integritetspolicy</a>, vilken bland annat beskriver grunderna för behandling av mina personuppgifter (punkt 2) samt mina rättigheter (punkt 7).', {link: this.links.integritetspolicy});

        }
    },

    created() {
        // Merge translations.
        Object.assign(translations, this.translations);

        // Add CSRF token to the payload.
        axios.get('/actions/alandsbanken/alandsbanken/csrf-token')
            .then(({data}) => {
                this.formData[window.csrfTokenName] = data.csrfToken;
                this.loading = false;
            })

            // console.log('options', this.options);
    },

    filters: {
        t(string, params = {}) {
            return translate(string, params);
        },

        join(array, separator = ', ') {
            return join(array, separator);
        }
    },

    methods: {
        nextPage() {
            this.formData['page'] = this.currentPage;
            this.loading = true;
            if (this.currentLocale === 'sv-SE') {
                let request = axios({
                    method: 'post',
                    url: '/actions/loanapplication/loan-application/submit-swedish',
                    baseURL: ALANDSBANKEN.siteUrl,
                    data: this.formData,
                }).then(({data}) => {
                    // console.log('file: LoanApplicationForm.vue ~ line 795 ~ nextPage ~ data', data);
                    if (data.status == 'success') {
                        this.errors = {};
                        this.currentPage++;
                        this.loading = false;
                    }

                    if (data.status == 'error') {
                        this.errors = data.errors;
                        this.$el.scrollIntoView();
                        this.loading = false;
                    }
                }).catch(error => {
                    // console.log(error);
                })
            } else {
                let request = axios({
                    method: 'post',
                    url: '/actions/loanapplication/loan-application/submit',
                    baseURL: ALANDSBANKEN.siteUrl,
                    data: this.formData,
                }).then(({data}) => {
                    if (data.status == 'success') {
                        this.errors = {};
                        this.currentPage++;
                        this.loading = false;
                    }

                    if (data.status == 'error') {
                        this.errors = data.errors;
                        this.$el.scrollIntoView();
                        this.loading = false;
                    }
                }).catch(error => {
                    // console.log(error);
                })
            }
        },

        previousPage() {
            this.errors = {};
            this.currentPage--;
        },

        addExistingLoan() {
            this.formData.befintligaLan.push(this.existingLoanData());
        },

        removeExistingLoan(index) {
            // console.log(index);
            this.formData.befintligaLan.splice(index, 1);
        },

        handleSubmit(event) {
            this.nextPage();
        },

        applicantData() {
            return {
                fornamn: '',
                efternamn: '',
                personnummer: '',
                adress: '',
                postnummer: '',
                ort: '',
                telefon: '',
                epost: '',
                civilstand: '',
                antalBarn: '',
                boendeform: '',
                utbildning: '',
                arbetsgivare: '',
                yrke: '',
                telefonArbete: '',
                anstallningsform: '',
                anstalldAr: '',
                arbetserfarenhetTotalt: '',
                inkomsterBrutto: '',
                inkomsterNetto: '',
                kapitalinkomsterNetto: '',
                ovrigaInkomster: '',
                andelAvBoendekostnader: '',
                andelAvOvrigaKostnader: '',
                andraUtgifter: '',
                bostadMarknadsvarde: '',
                sparandeIAlandsbanken: '',
                sparandeIAndraBanker: '',
                bostaderOchAndraTillgangar: '',
                finansiellaTillgangar: '',
                lanMedSakerhetIAndraBanker: '',
                lanUtanSakerhetIAndraBanker: '',
            };
        },

        applicantDataSweden() {
            return {
                foernamnefternamn: '',
                adress: '',
                telefon: '',
                email: '',
                sparande: '',
                foedelsear: '',
                nettoloensekMan: '',
                arbetsgivare: '',
                anstallningsform: '',
            };
        },

        existingLoanData() {
            return {
                langivare: '',
                nuvarandeLanebelopp: '',
                bundet: '',
                eventuellSakerhet: '',
            }
        },

        pageIndicator(pageNumber) {

            let currentPage = this.currentPage;
            let isNotFirstPage = pageNumber != 1;
            let isNotLastPage = pageNumber != 10;
            let isNotPreviousPage = currentPage - 1 != pageNumber;
            let isNotNextPage = currentPage + 1 != pageNumber;
            let isNotCurrentPage = currentPage != pageNumber;

            return {
                'invisible md:visible w-0 md:w-auto': isNotFirstPage && isNotLastPage && isNotPreviousPage && isNotNextPage && isNotCurrentPage,
                'visited': currentPage > pageNumber,
                'current': currentPage == pageNumber,
            };
        },

        selectedBoendeform(value) {
            let boendeformOptions = this.options.sokande.boendeform;
            return find(boendeformOptions, (o, i) => {return i == value});
        },

        selectedUtbildning(value) {
            let utbildningOptions = this.options.sokande.utbildning;
            return find(utbildningOptions, (o, i) => {return i == value});
        },

        selectedAnstallningsform(value) {
            let anstallningsformOptions = this.options.sokande.anstallningsform;
            return find(anstallningsformOptions, (o, i) => {return i == value});
        },

        getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return '';
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    },

    watch: {
        'formData.antalSokande': function(value) {
            while (value <= 2 && this.formData.sokande.length < value) {
                this.formData.sokande.push(window.currentLocale === 'sv-SE' ? this.applicantDataSweden() : this.applicantData());
            }

            while (value >= 1 && this.formData.sokande.length > value) {
                this.formData.sokande.pop();
            }
        },

        currentPage: function() {
            this.$nextTick(() => {
                this.$el.scrollIntoView();

                let input = this.$el.querySelector('input, select, textarea');
                if (input) {
                    input.focus();
                }
            })
        }
    }
}

</script>
